var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4001 3.19999C5.5514 3.19999 4.73747 3.53714 4.13736 4.13725C3.53724 4.73737 3.2001 5.5513 3.2001 6.39999C3.2001 7.24869 3.53724 8.06262 4.13736 8.66274C4.73747 9.26285 5.5514 9.59999 6.4001 9.59999C7.24879 9.59999 8.06272 9.26285 8.66284 8.66274C9.26296 8.06262 9.6001 7.24869 9.6001 6.39999C9.6001 5.5513 9.26296 4.73737 8.66284 4.13725C8.06272 3.53714 7.24879 3.19999 6.4001 3.19999ZM1.6001 6.39999C1.6 5.64456 1.77821 4.89976 2.12023 4.22619C2.46226 3.55261 2.95844 2.96927 3.56841 2.52361C4.17839 2.07796 4.88495 1.78256 5.63061 1.66146C6.37628 1.54036 7.14 1.59696 7.85967 1.82667C8.57933 2.05638 9.23462 2.45271 9.77223 2.98343C10.3098 3.51415 10.7146 4.16426 10.9536 4.8809C11.1926 5.59754 11.259 6.36047 11.1476 7.10764C11.0361 7.8548 10.7498 8.56511 10.3121 9.18079L14.1657 13.0344C14.3114 13.1853 14.3921 13.3874 14.3902 13.5971C14.3884 13.8069 14.3043 14.0075 14.156 14.1558C14.0076 14.3042 13.807 14.3883 13.5972 14.3901C13.3875 14.392 13.1854 14.3113 13.0345 14.1656L9.1817 10.3128C8.46359 10.8234 7.61878 11.1265 6.73984 11.1889C5.8609 11.2513 4.98176 11.0705 4.19874 10.6664C3.41572 10.2623 2.75905 9.65042 2.30068 8.89787C1.84231 8.14533 1.59993 7.28114 1.6001 6.39999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e04b21ec5ceb0f67eb80536fc3d4e69e.svg";
export { ForwardRef as ReactComponent };